import { useEffect, useState } from 'react';
import type { Dispatch, SetStateAction } from 'react';

import type { IssueDetailsTab } from '.';

/**
 * Handles resetting the tab to the first tab whenever the Drawer is opened.
 *
 * @param {boolean} isDrawerOpen - Whatever is determining if the drawer is open.
 */
function useIssueDetailsTabs(
  isDrawerOpen: boolean,
): [IssueDetailsTab, Dispatch<SetStateAction<IssueDetailsTab>>] {
  const [activeTab, setActiveTab] = useState<IssueDetailsTab>('issue');

  //  Update the active tab to 'issue' when the drawer opens.
  //  Note that this only runs once when this prop changes, not the entire time the Drawer is open.
  useEffect(() => {
    if (isDrawerOpen) {
      setActiveTab('issue');
    }
  }, [isDrawerOpen]);

  return [activeTab, setActiveTab];
}

export default useIssueDetailsTabs;
